import { useEffect, useRef } from 'react';

const useSwipeNavigation = (nextImage, prevImage) => {
  const startX = useRef(0);
  const startY = useRef(0);
  const isDragging = useRef(false);
  const minSwipeDistance = 50; // Minimum distance for swipe to register

  useEffect(() => {
    const handleStart = (clientX, clientY) => {
      startX.current = clientX;
      startY.current = clientY;
      isDragging.current = true;
    };

    const handleMove = (clientX, clientY) => {
      if (!isDragging.current) return;

      const deltaX = startX.current - clientX;
      const deltaY = startY.current - clientY;

      // Prevent vertical scrolling if horizontal movement is detected
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        // Prevent default to avoid page scrolling
        event.preventDefault();
      }
    };

    const handleEnd = (clientX, clientY) => {
      if (!isDragging.current) return;

      const deltaX = startX.current - clientX;
      const deltaY = startY.current - clientY;

      // Only trigger swipe if horizontal movement is greater than vertical
      // and exceeds minimum distance
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX > 0) {
          nextImage(); // Swipe left - next image
        } else {
          prevImage(); // Swipe right - previous image
        }
      }

      isDragging.current = false;
    };

    // Mouse events
    const handleMouseDown = (event) => {
      handleStart(event.clientX, event.clientY);
    };

    const handleMouseMove = (event) => {
      handleMove(event.clientX, event.clientY);
    };

    const handleMouseUp = (event) => {
      handleEnd(event.clientX, event.clientY);
    };

    // Touch events
    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      handleStart(touch.clientX, touch.clientY);
    };

    const handleTouchMove = (event) => {
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        handleMove(touch.clientX, touch.clientY);
      }
    };

    const handleTouchEnd = (event) => {
      if (event.changedTouches.length === 1) {
        const touch = event.changedTouches[0];
        handleEnd(touch.clientX, touch.clientY);
      }
    };

    // Add event listeners
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    document.addEventListener('touchstart', handleTouchStart, { passive: false });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);

      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [nextImage, prevImage]);
};

export default useSwipeNavigation;

